const scenarioAnswerOption = {
    text: "",
    nextQuestionId: null,
    order: 0,
    questionId: null,
};

export { scenarioAnswerOption };
